import { Injector } from "@angular/core";
import { ListView } from "../../../Data/ListView";
import { Art57Node } from "../Art57Node";
import { Art57NodeList } from "../Art57NodeList";
import { TreeNodeAuthorisedProduct } from "../Entity/TreeNodeAuthorisedProduct";
import { TreeNodeDrugATC } from "../Entity/TreeNodeDrugATC";
import { ErrorType } from "../../ErrorType";
import { environment } from "../../../../../../environments/environment";

export class TreeNodeDrugsATCList extends Art57NodeList {
    constructor(injector: Injector, parent: Art57Node) {
      super(injector, new ListView(), 'Drug ATCs ({param})');
      this.parent = parent;
      this.labelNodeName = 'Drug ATCs';
    }
  
    override refreshLabel(): void {
      this.label = this.labelTemplate.replace(
        '{param}',
        this.getLabelParamFromChildren()
      );
    }
  
    override createChildTemplate(): Art57Node[] | null {
      let node = new TreeNodeDrugATC(this.ioc!, this);
      this.children?.push(node);
  
      this.refreshLabel();
      return [node];
    }
  
    override validateBusinessRules(): any[] {
      let errors: any = [];
      if (this.parent instanceof TreeNodeAuthorisedProduct) {
        if (!this.children || this.children.length == 0) {
          errors.push({
            node: this,
            errorID: this.key,
            errorType: ErrorType.bussinessValidationError,
            controlId: undefined,
            controlLabel: '',
            error: 'Section is Mandatory',
          });
        } else {
          errors.push({
            node: this,
            errorID: this.key,
            errorType: ErrorType.errorInactive,
            controlId: undefined,
            controlLabel: '',
            error: '',
          });
        }
      }
  
      return errors;
    }
  
    override getMessage(): any {
      let productatcs: Art57Node[] = [];
      this.children?.forEach((node) => {
        let productatc = node as Art57Node;
        productatcs.push(productatc.getMessage());
      });
      if (productatcs.length > 0) {
        return { productatcs: { productatc: productatcs } };
      } else {
        return undefined;
      }
    }
  
    override getHeaders(): string[] {
      return ['EV Code', 'ATC Code'];
    }
  
    override cloneNode(newParent: Art57Node): Art57Node|undefined {
      let clonedNode: TreeNodeDrugsATCList = new TreeNodeDrugsATCList(
        this.ioc!,
        newParent
      );
  
      this.children?.forEach((child) => {
        let childToClone = child as Art57Node;
        let clonedChildren = childToClone.cloneNode(clonedNode);
        if (clonedChildren) {
            clonedNode.children?.push(clonedChildren);
            clonedChildren.refreshLabel();
        }
      });
  
      clonedNode.refreshLabel();  
      clonedNode.expanded = this.expanded && (environment.userPreferences.autoexpandNodesOnCloning ||environment.userPreferences.alwaysAutoexpandNodes)

  
      return clonedNode;
    }
  }

